import { render, staticRenderFns } from "./ImportStatsModal.vue?vue&type=template&id=6ed8f118"
import script from "./ImportStatsModal.vue?vue&type=script&lang=js"
export * from "./ImportStatsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports